const ENV = process.env;
export const ENVIRONMENT = {
  RAZORPAY_KEY: ENV.REACT_APP_RAZORPAY_KEY,
  RAZORPAY_KEY_DONATION: ENV.REACT_APP_RAZORPAY_KEY_DONATION,
  MAP_key: ENV.REACT_APP_GOOGLE_API_KEY,
  GAME_URL_RAM_MANDIR_NIRMAN_EASY: ENV.REACT_APP_GAME_URL_RAM_MANDIR_NIRMAN_EASY,
  GAME_URL_RAM_MANDIR_NIRMAN_HARD: ENV.REACT_APP_GAME_URL_RAM_MANDIR_NIRMAN_HARD,
  GAME_URL_MANDIR_DARSHAN: ENV.REACT_APP_GAME_URL_MANDIR_DARSHAN,
  GAME_URL_PRABHU_SHINGAR: ENV.REACT_APP_GAME_URL_PRABHU_SHINGAR,
  GAME_URL_BHOJNALYA: ENV.REACT_APP_GAME_URL_BHOJNALYA,
  GAME_URL_BAGICHA: ENV.REACT_APP_GAME_URL_BAGICHA,
  RAZORPAY_URL: ENV.REACT_APP_RAZORPAY,
  URL_LINK: ENV.REACT_APP_SHARE_URL
};
// export const URL_LINK = `https://www.stage-user.satyug.life/?id=`
export const FORMIK_REGEX = {
  ALPHA_REGEX: /^[A-Za-z\s]+$/,
  MOBILE_NUMBER_REGEX: /^\+(?:[0-9]●?){6,16}[0-9]$/,
  EMAIL_REGEX:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  EMAIL_REGEX_NEW:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  ADDRESS_REGEX: /^[a-zA-Z a-zA-Z0-9\n-/@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/,
  POSTAL_REGEX: /^(\d{4}|\d{10})$/,
  NUMERIC_REGEX: /^\d+$/,
};
export const GAME_TOKEN = {
  GameAccessToken: "GameAccessToken",
  GameVerifyToken: "GameVerifyToken",
  UserRegisterToken: "UserRegisterToken",
  Collectible: "collectible",
};

export const S3_BUCKET = {
  MAINTENANCE: "https://thumbs.dreamstime.com/z/yellow-street-concept-maintenance-sign-yellow-street-concept-maintenance-sign-isolated-white-background-close-127194779.jpg?w=360%20360w,%20https://thumbs.dreamstime.com/z/yellow-street-concept-maintenance-sign-yellow-street-concept-maintenance-sign-isolated-white-background-close-127194779.jpg?w=400%20400w,%20https://thumbs.dreamstime.com/z/yellow-street-concept-maintenance-sign-yellow-street-concept-maintenance-sign-isolated-white-background-close-127194779.jpg?w=450%20450w,%20https://thumbs.dreamstime.com/z/yellow-street-concept-maintenance-sign-yellow-street-concept-maintenance-sign-isolated-white-background-close-127194779.jpg?w=576%20576w,%20https://thumbs.dreamstime.com/z/yellow-street-concept-maintenance-sign-yellow-street-concept-maintenance-sign-isolated-white-background-close-127194779.jpg?w=768%20768w,%20https://thumbs.dreamstime.com/z/yellow-street-concept-maintenance-sign-yellow-street-concept-maintenance-sign-isolated-white-background-close-127194779.jpg?w=992%20992w",
  URL: "https://dvf7opio6knc7.cloudfront.net",
  IMAGESLOGO: "https://dvf7opio6knc7.cloudfront.net/digital-logo1.png",
  IMAGES: "https://dvf7opio6knc7.cloudfront.net/satyugImages",
  VIDEOS: "https://dvf7opio6knc7.cloudfront.net/satyugvideos",
  SHIRT: "https://dvf7opio6knc7.cloudfront.net/products/t-shirt.png",
  CAP: "https://dvf7opio6knc7.cloudfront.net/products/cap.png",
  BEFORE_GAME: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/BeforeGam.mp4",
  CINEMATIC_GAME: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/Construction.mp4",
  DAKSHINA_GAME: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/Bhojnalya_stage.mp4",
  SATHAPNA_GAME: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/Murti_stage.mp4",
  NIRMAAN_GAME: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/bagicha-stage.mp4",
  ABOUT_US_TEXT: "https://dvf7opio6knc7.cloudfront.net/satyugImages/about-us.png",
  CLICK_TO_ENTER_TEXT: "https://dvf7opio6knc7.cloudfront.net/satyugImages/click-to-enter.png",
  SATYUG_VIDEO_POSTER: "https://dvf7opio6knc7.cloudfront.net/satyugImages/satyug-video-poster.webp",
  SHARE_PAGE_VIDEO: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/BahumulyaWEBM.webm",
  USER_NOT_EXIST_VIDEO: "https://dvf7opio6knc7.cloudfront.net/video_v2/02.webm",
  BAGEECHA: "https://dvf7opio6knc7.cloudfront.net/satyugImages/bageecha.webp",
  MURTI_STHAPANA: "https://dvf7opio6knc7.cloudfront.net/satyugImages/murthi-sathapna.webp",
  BHOJNALYA: "https://dvf7opio6knc7.cloudfront.net/satyugImages/bhojnalaya.webp",
  MANDIR: "https://dvf7opio6knc7.cloudfront.net/satyugImages/card-image.webp",
  SHARE_IMAGE: "https://dvf7opio6knc7.cloudfront.net/satyugImages/share-image.webp",
  ABOUT_US_HIGH: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/about-us.mp4",
  ABOUT_US_LOW: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/about-us-low.mp4",
  ABOUT_US_480: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/about-us-480.mp4",
  ABOUT_US_720: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/about-us-720.mp4",
  SATYUG_VIDEO: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/Satyug.mp4",
  SATYUG_VIDEO_LOW: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/satyug-low.mp4",
  DHYANA_VIDEO: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/dhyana.mp4",
  DHYANA_VIDEO_LOW: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/dhyana-low.mp4",
  YOGA_VIDEO: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/yoga.mp4",
  YOGA_VIDEO_LOW: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/yoga-low.mp4",
  SHARE_BACK: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/sharevideo.mp4",
  ABOUT_US_POSTER: "https://dvf7opio6knc7.cloudfront.net/satyugImages/about-us-poster.png",
  LOGO_HD: "https://dvf7opio6knc7.cloudfront.net/satyugImages/logo-hd.webp",
  BEFORE_GAME_720: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/before-game-720.mp4",
  BEFORE_GAME_480: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/before-game-480.mp4",
  BEFORE_GAME_360: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/before-game-360.mp4",
  SHARE_360: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/share-360.mp4",
  SHARE_480: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/share-480.mp4",
  OLD_LOGO: "https://dvf7opio6knc7.cloudfront.net/satyugImages/satyug-old-logo.webp",
  BADHAI: "https://dvf7opio6knc7.cloudfront.net/satyugvideos/Badhai (1).webm",
  DIGITAL_LOGO: "https://dvf7opio6knc7.cloudfront.net/satyugImages/digital-logo.png",
  PRABHU_SHINGAR: "https://dvf7opio6knc7.cloudfront.net/video_v2/webm/prabhu_shingaar.webm",
  BAGICHA_NIRMAN: "https://dvf7opio6knc7.cloudfront.net/video_v2/webm/bagicha_nirmaan.webm",
  BHOJNALYA_YOGDAN: "https://dvf7opio6knc7.cloudfront.net/video_v2/webm/Aap_ka_yogdaan.webm",
  WELCOME_FLAG: "https://dvf7opio6knc7.cloudfront.net/satyugImages/welcome-flag.png",
  WELCOME_LEFT_ARROW: "https://dvf7opio6knc7.cloudfront.net/satyugImages/welcome-arrow-left.png",
  WELCOME_RIGHT_ARROW: "https://dvf7opio6knc7.cloudfront.net/satyugImages/welcome-flag-right.png",
  UP_BOW: "https://dvf7opio6knc7.cloudfront.net/satyugImages/up-bow.png",
  SILVER_BOW: "https://dvf7opio6knc7.cloudfront.net/satyugImages/silver-bow.png",
  CERTIFICATE: "https://dvf7opio6knc7.cloudfront.net/satyugImages/sample-certificate",
  EASY_MODE: "https://dvf7opio6knc7.cloudfront.net/satyugImages/easy-mode.png",
  HARD_MODE: "https://dvf7opio6knc7.cloudfront.net/satyugImages/hard-mode.png",
  AFTER_END_BUY: "https://dvf7opio6knc7.cloudfront.net/video_v2/E-commerce%20web%20site%20last%20dialogue.webm",
  BEFORE_END_BUY: "https://dvf7opio6knc7.cloudfront.net/video_v2/Augumented_Reality_WEBM.webm",
  BEFORE_SHARE_END: "https://dvf7opio6knc7.cloudfront.net/video_v2/webm/Skip_Dialogue_WEBM.webm",
  BRICK: "https://dvf7opio6knc7.cloudfront.net/products/brick.png",
  EMAIL_VERIFY_SAFARI: "https://dvf7opio6knc7.cloudfront.net/video_v2/safari/mandir_nirmand_02.mp4",
  AFTER_END_BUY_SAFARI: "https://dvf7opio6knc7.cloudfront.net/video_v2/safari/site%20last%20dialogue_01.mp4",
  BADHAI_SAFARI: "https://dvf7opio6knc7.cloudfront.net/video_v2/safari/Badhai.mp4",
  BEFORE_SHARE_END_SAFARI: "https://dvf7opio6knc7.cloudfront.net/video_v2/safari/Skip_Dialogue_WEBM.mp4",
  PRABHU_SHINGAR_SAFARI: "https://dvf7opio6knc7.cloudfront.net/video_v2/safari/prabhu_shingaar.mp4",
  BAGICHA_NIRMAN_SAFARI: "https://dvf7opio6knc7.cloudfront.net/video_v2/safari/bagicha_nirmaan.mp4",
  BHOJNALYA_YOGDAN_SAFARI: "https://dvf7opio6knc7.cloudfront.net/video_v2/safari/Aap_ka_yogdaan.mp4",
  BEFORE_END_BUY_SAFARI: "https://dvf7opio6knc7.cloudfront.net/video_v2/safari/Augumented_Reality_WEBM.mp4",
  LOGIN_SAFARI: "https://dvf7opio6knc7.cloudfront.net/video_v2/safari/hanuman_whatsapp_share_Side.mp4",
  MOMENTO_WALL_FRAME: "https://dvf7opio6knc7.cloudfront.net/satyugImages/momento-wall-framer.png",
  MOMENTO_BOX: "https://dvf7opio6knc7.cloudfront.net/satyugImages/momento-box.png",
};
export const S3_BUCKET_AUDIO = {
  AFTER_GAME: "https://dvf7opio6knc7.cloudfront.net/audio/AfterGame.mp3",
  DONATE: "https://dvf7opio6knc7.cloudfront.net/audio/Donate.mp3",
  MANDIR_CONSTRUCTION:
    "https://dvf7opio6knc7.cloudfront.net/audio/MandirConstruction.mp3",
  QUIZ: "https://dvf7opio6knc7.cloudfront.net/audio/Quiz.mp3",
  SHARE: "https://dvf7opio6knc7.cloudfront.net/audio/share.mp3",
  PARTICIPATION: "https://dvf7opio6knc7.cloudfront.net/audio/participation.mp3",
  BUYAUDIO: "https://dvf7opio6knc7.cloudfront.net/audio/Cap%20Tshirt_VO.mp3",
};

export const NETWORK_SPEED = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
}


export const SCREEN_SIZE = {
  MOBILE: "MOBILE",
  TAB: "TAB",
  DESKTOP: "DESKTOP",
}

export const SOCIAL_MEDIA = {
  TWITTER: "https://twitter.com/SatyugLife",
  GITHUB: "https://github.com/Satyug-life/Satyug-website",
  DISCORD: "https://discord.gg/Tg5m53ah",
  REDDIT: "https://www.reddit.com/r/satyug/",
  TELEGRAM: "https://t.me/+h5ablpKtH39mYzg1",
  WHITEPAPER: "https://dvf7opio6knc7.cloudfront.net/satyugImages/Satyug Whitepaper.pdf",
  LIGHTPAPER: "https://dvf7opio6knc7.cloudfront.net/satyugImages/Satyug%20Lightpaper.pdf",
  FACEBOOK: "https://www.facebook.com/DigitalRamMandir?mibextid=ZbWKwL",
  INSTAGRAM: "https://www.instagram.com/digitalrammandir?utm_source=qr&igshid=YTlmZjI0ZWMzOA==",
}

export const getPriceForType = (type) => {
  switch (type) {
    case 1:
      return 50;
    case 2:
      return 100;
    case 3:
      return 200;
    case 4:
      return 2100;
    default:
      // Handle unknown types or provide a default value
      return 0;
  }
};

export const getThaliType = (type) => {
  switch (type) {
    case 1:
      return 'Thali with 1 diya + phool + Mishri prasad';
    case 2:
      return 'Thali with 5 diya + Ghanti + phool + laddu prasad';
    case 3:
      return 'Large aarti stand + peda prasad';
    case 4:
      return 'Physical puja + prasad option';
    default:
      // Handle unknown types or provide a default value
      return 0;
  }
};

export const productType = (type) => {
  switch (type) {
    case 1:
      return 't-shirt';
    case 2:
      return 'cap';
    default:
      return 'unknown';
  }
};

export const getBrowserType = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.includes("Chrome")) {
    return "Chrome";
  } else if (userAgent.includes("Firefox")) {
    return "Firefox";
  } else if (userAgent.includes("Safari")) {
    return "Safari";
  } else if (userAgent.includes("MSIE") || userAgent.includes("Trident/")) {
    return "Internet Explorer";
  } else if (userAgent.includes("Edge")) {
    return "Microsoft Edge";
  } else {
    return "Unknown";
  }
}


export const safariLangType = (type) => {
  switch (type) {
    case '/en/en':
      return 'en';
    case '/en/hi':
      return 'hi';
    case '/en/bn':
      return 'bn';
    case '/en/gu':
      return 'gu';
    case '/en/kn':
      return 'kn';
    case '/en/mr':
      return 'mr';
    case '/en/ta':
      return 'ta';
    case '/en/te':
      return 'te';
    default:
      return 'en';
  }
};



